var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 20.1667C20.5502 20.1667 23.8334 16.8834 23.8334 12.8333C23.8334 8.78325 20.5502 5.5 16.5001 5.5C12.45 5.5 9.16675 8.78325 9.16675 12.8333C9.16675 16.8834 12.45 20.1667 16.5001 20.1667Z",
    stroke: "#121212",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 38.5V34.8333C5.5 32.8884 6.27262 31.0232 7.64788 29.6479C9.02315 28.2726 10.8884 27.5 12.8333 27.5H20.1667C22.1116 27.5 23.9769 28.2726 25.3521 29.6479C26.7274 31.0232 27.5 32.8884 27.5 34.8333V38.5",
    stroke: "#121212",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 5.73804C30.9107 6.14192 32.3088 7.05932 33.3073 8.34561C34.3057 9.63189 34.8476 11.2139 34.8476 12.8422C34.8476 14.4705 34.3057 16.0525 33.3073 17.3388C32.3088 18.6251 30.9107 19.5425 29.3333 19.9464",
    stroke: "#121212",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 38.5004V34.8337C38.4907 33.2152 37.9462 31.6452 36.9513 30.3685C35.9565 29.0917 34.5672 28.18 33 27.7754",
    stroke: "#121212",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfIcon);
export default __webpack_public_path__ + "static/media/prof-icon.1b7bd7f784d211a7a95638eba88e75a6.svg";
export { ForwardRef as ReactComponent };